// Curated marketing/static data for landing page sections (TripAdvisor-style).

export const TRENDING_DESTINATIONS = [
  {
    city: 'Amritsar',
    state: 'Punjab',
    image: 'https://images.unsplash.com/photo-1623059508779-2542c6e83753?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    tagline: 'Golden Temple · Wagah Border',
  },
  {
    city: 'Chandigarh',
    state: 'Union Territory',
    image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    tagline: 'Rock Garden · Sukhna Lake',
  },
  {
    city: 'Gurugram',
    state: 'Haryana',
    image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    tagline: 'Cyber Hub · Kingdom of Dreams',
  },
  {
    city: 'Ludhiana',
    state: 'Punjab',
    image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    tagline: 'Manchester of India',
  },
  {
    city: 'Jalandhar',
    state: 'Punjab',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    tagline: 'Doaba Heart · Wonderland',
  },
];

export const PROPERTY_TYPES = [
  { id: 'hotel', label: 'Hotels', icon: 'Hotel', count: 28 },
  { id: 'motel', label: 'Motels', icon: 'BedDouble', count: 4 },
  { id: 'resort', label: 'Resorts', icon: 'Palmtree', count: 3 },
  { id: 'homestay', label: 'Homestays', icon: 'Home', count: 12 },
  { id: 'apartment', label: 'Apartments', icon: 'Building2', count: 9 },
  { id: 'farmhouse', label: 'Farm Houses', icon: 'Trees', count: 6 },
  { id: 'bunkbed', label: 'Bunk Beds', icon: 'Bed', count: 5 },
  { id: 'hostel', label: 'Hostel & PG', icon: 'Users', count: 11 },
  { id: 'guesthouse', label: 'Guest Houses', icon: 'Tent', count: 8 },
];

export const TESTIMONIALS = [
  {
    id: 't1',
    quote:
      'Booked Taj Swarna in Amritsar through localliink.com — the rooftop view of the Golden Temple at dawn left me speechless. Booking was effortless and the rate was the best I found online.',
    name: 'Aanya Sharma',
    role: 'Travel Writer · Mumbai',
    avatar: 'https://images.pexels.com/photos/35233333/pexels-photo-35233333.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200',
    rating: 5,
  },
  {
    id: 't2',
    quote:
      'Drove down from Delhi to Chandigarh on a whim. localliink.com found me a JW Marriott room for ₹6,500 less than the brand site. Pay-at-hotel made it stress-free.',
    name: 'Rohan Kapoor',
    role: 'Foodie · Delhi NCR',
    avatar: 'https://images.unsplash.com/photo-1678855904567-d9e73fa2e01d?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 5,
  },
  {
    id: 't3',
    quote:
      'For our anniversary, we stayed at Baradari Palace in Patiala. The royal heritage rooms felt straight out of a film set. localliink.com’s nearby attractions guide was a chef’s kiss.',
    name: 'Manvir & Priya',
    role: 'Anniversary Trip · Ludhiana',
    avatar: 'https://images.pexels.com/photos/34030099/pexels-photo-34030099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200',
    rating: 5,
  },
  {
    id: 't4',
    quote:
      'Business trips to Gurugram are now my favourite — Oberoi confirmed in 30 seconds. The two-way rating system is genius; both guests and hotels are accountable.',
    name: 'Karan Mehta',
    role: 'Founder · SaaS startup',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 5,
  },
  {
    id: 't5',
    quote:
      'As a solo woman traveller exploring Wagah Border, I felt safe with localliink.com’s verified Amritsar properties. Hotel ratings on guests added an extra layer of trust.',
    name: 'Ishita Verma',
    role: 'Solo Traveller · Bengaluru',
    avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 5,
  },
  {
    id: 't6',
    quote:
      'Took our parents to Sultanpur Lodhi via Kapurthala. Imperial Heights for ₹1,900/night was unreal value. India deserves a TripAdvisor that gets North India — finally, here it is.',
    name: 'Simran Anand',
    role: 'Heritage Buff · Jalandhar',
    avatar: 'https://images.pexels.com/photos/3992656/pexels-photo-3992656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200',
    rating: 5,
  },
];

export const INSIGHTS = [
  {
    id: 'i1',
    type: 'guide',
    title: '48 Hours in Amritsar: A Local’s Guide to the Golden City',
    excerpt:
      'From dawn at the Golden Temple to a midnight Amritsari kulcha at Kesar Da Dhaba — your hour-by-hour itinerary curated by Punjab natives.',
    image:
      'https://images.unsplash.com/photo-1587135304577-c8aef9f12b8f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Amritsar',
    readTime: '7 min read',
  },
  {
    id: 'i2',
    type: 'trending',
    title: 'Top 5 Heritage Stays in Patiala You Can Book Today',
    excerpt:
      'Live like a Maharaja in royal palace hotels reborn as luxury heritage stays. Curated by our editors with verified pricing for 2026.',
    image:
      'https://images.unsplash.com/photo-1618773928121-c32242e63f39?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Patiala',
    readTime: '5 min read',
  },
  {
    id: 'i3',
    type: 'guide',
    title: 'Chandigarh on a Budget: Where to Stay Under ₹3,500/night',
    excerpt:
      'Sector 17 boutique stays, sector 35 hidden gems, and Zirakpur’s best-kept secrets — Le Corbusier’s city without breaking the bank.',
    image:
      'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Chandigarh',
    readTime: '6 min read',
  },
  {
    id: 'i4',
    type: 'trending',
    title: 'Why Gurugram Is India’s Hottest Business-Leisure Destination',
    excerpt:
      'Cyber Hub by day, Kingdom of Dreams by night. We rank the 8 best hotels for the new-age corporate traveller.',
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Gurugram',
    readTime: '4 min read',
  },
  {
    id: 'i5',
    type: 'guide',
    title: 'The Ludhiana Foodie Trail: 12 Stops Every Traveller Must Make',
    excerpt:
      'From Bade Bhai Ka Brothers Dhaba to the iconic Punjabi Rasoi — a Doaba-style food crawl mapped to nearby hotels.',
    image:
      'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Ludhiana',
    readTime: '8 min read',
  },
  {
    id: 'i6',
    type: 'trending',
    title: 'The Punjabi Wedding Hotel Guide: Banquet Halls + Stays',
    excerpt:
      'Planning the big fat Punjabi wedding? Our shortlist of properties with sprawling lawns, banquet capacity, and bridal suites.',
    image:
      'https://images.unsplash.com/photo-1571896349842-33c89424de2d?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    city: 'Punjab',
    readTime: '6 min read',
  },
];
